/**
 * Feature Flags Redux Slice
 *
 * Manages feature availability state fetched from backend status endpoints.
 * Used to conditionally show/hide UI elements based on backend configuration.
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/index';
import { api } from '../../services/api';

interface FeatureFlagsState {
  cadEnabled: boolean | null;
  loading: boolean;
}

const initialState: FeatureFlagsState = {
  cadEnabled: null,
  loading: false,
};

export const fetchCadStatus = createAsyncThunk(
  'featureFlags/fetchCadStatus',
  async () => {
    const data = await api.get<{ enabled: boolean }>('/cad/status');
    return data.enabled;
  },
);

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCadStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCadStatus.fulfilled, (state, action) => {
        state.cadEnabled = action.payload;
        state.loading = false;
      })
      .addCase(fetchCadStatus.rejected, (state) => {
        state.cadEnabled = false;
        state.loading = false;
      });
  },
});

export const selectCadEnabled = (state: RootState) => state.featureFlags.cadEnabled;

export default featureFlagsSlice.reducer;
